import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VerificationFailuresComponent } from './verification-failures.component';
import { AttemptsExceededComponent } from './attempts-exceeded/attempts-exceeded.component';
import { FailureMessageComponent } from './failure-message/failure-message.component';

@NgModule({
  imports: [CommonModule, AttemptsExceededComponent],
  declarations: [VerificationFailuresComponent, FailureMessageComponent],
  exports: [AttemptsExceededComponent],
})
export class UserVerificationUiVerificationFailuresModule {}
